<div
	class="grid gap-6 w-full p-10"
	style="grid-template-columns: 100px 1fr min-content"
>
	<div class="col-span-3">
		<app-back-to-integrations-button></app-back-to-integrations-button>
	</div>

	<img *ngIf="!fct" src="/assets/images/integrations/llc-logo.png" />
	<img *ngIf="fct" src="/assets/images/integrations/fct-logo.svg" />

	<div class="flex flex-col gap-6 w-full">
		<div class="text-2xl font-bold">
			<ng-container *ngIf="!fct">Lender Lawyer Connect</ng-container>
			<ng-container *ngIf="fct">First Canadian Title</ng-container>
		</div>

		<p *ngIf="!fct">
			Simplify and digitize the instructing processing, reporting and document
			handling of your TD, BNS and MMS residential mortgages at no cost.
		</p>
		<p *ngIf="fct">
			Order title insurance from this industry leading provider without leaving
			Closer.
		</p>

		<ng-container *ngIf="connectedUsers$ | async as connectedUsers">
			<app-container *ngIf="connectedUsers.length; else noneConnected">
				<table mat-table [dataSource]="connectedUsers" class="w-full">
					<!-- initials -->
					<ng-container matColumnDef="initials">
						<th mat-header-cell *matHeaderCellDef>Name</th>
						<td mat-cell *matCellDef="let element">
							<atomic-name-badge
								[name]="element.name"
								size="small"
							></atomic-name-badge>
						</td>
					</ng-container>

					<!-- name -->
					<ng-container matColumnDef="name">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let element">
							{{ element.name }}
						</td>
					</ng-container>

					<!-- status -->
					<ng-container matColumnDef="status">
						<th mat-header-cell *matHeaderCellDef>Status</th>
						<td mat-cell *matCellDef="let element" class="text-grey-light">
							<app-icon [icon]="ICON.LIGHTNING_BOLT" class="mr-4"></app-icon
							>Connected
						</td>
					</ng-container>

					<!-- action -->
					<ng-container matColumnDef="action">
						<th mat-header-cell *matHeaderCellDef>
							<app-button
								btn="clear"
								size="large"
								[icon]="ICON.ADD"
								class="text-green font-bold"
								(click)="connect()"
							></app-button>
						</th>
						<td mat-cell *matCellDef="let element">
							<atomic-button-dropdown
								*ngIf="element.canRevoke"
								[icon]="ICON.KEBAB"
								btn="clear"
								[itemGroups]="[
									{
										items: [
											{
												name: 'Revoke',
												item: { action: ACTIONS.REVOKE, id: element.id },
											},
										],
									},
								]"
								(onSelect)="rowActionClick($event.result.item)"
							></atomic-button-dropdown>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				</table>
			</app-container>
		</ng-container>

		<ng-template #noneConnected>
			<app-button (click)="connect()" size="small">Connect</app-button>
		</ng-template>

		<app-profile-benefits [benefits]="benefits"></app-profile-benefits>
	</div>

	<div>
		<app-container title="Resources" type="dark">
			<div class="text-sm whitespace-nowrap">
				<app-anchor
					[icon]="ICON.EXTERNAL"
					[external]="true"
					url="https://llc.firstcdn.com/Profile/Signup.aspx"
					>New to {{ fct ? 'FCT' : 'LLC' }}? Enroll now</app-anchor
				>
				<app-anchor
					*ngIf="profileUrl$ | async as profileUrl"
					[external]="true"
					[icon]="ICON.EXTERNAL"
					[url]="profileUrl"
					class="mt-2"
					>View my {{ fct ? 'FCT' : 'LLC' }} profile</app-anchor
				>
				<app-anchor
					*ngIf="!fct && profileUrl$ | async as profileUrl"
					[external]="true"
					[icon]="ICON.EXTERNAL"
					[url]="profileUrl"
					class="mt-2"
					>Add delegate(s)</app-anchor
				>
			</div>
		</app-container>
	</div>
</div>
